import React from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';

import { useTimeModal } from '../TimeModal/TimeModalContext';
import { formatNull, formatDateTime } from '../../Utils/GlobalUtils';

import LoadingLines from '../LoadingLines';
import Loading from '../Loading';
import WarningPanel from '../WarningPanel';

import ModalRight from '../ModalRight';
import FileViewerModal from '../FileViewerModal';

import AddNewPDConsentTemplate from './Components/AddNewPDConsentTemplate';

import IconContainer from '../IconContainer';
import { ReactComponent as PenIcon } from '../../icons/pen.svg';
import { ReactComponent as TrashIcon } from '../../icons/trash.svg';
import { ReactComponent as EyeIcon } from '../../icons/eye.svg';
import { ReactComponent as ReloadIcon } from '../../icons/reload.svg';

const TemplatesConsentPersonalData = ({ userId }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { openTimeModal } = useTimeModal();

  const [cases, setCases] = React.useState([]);

  const [warning, setWarning] = React.useState('');
  const [reload, setReload] = React.useState(true);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const token = localStorage.getItem('token');

    setLoading(true);

    axios.get("/api/get-service-files", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        type: "templateConsentPD",
      },
    })
    .then((response) => {
      setWarning('');
      setCases(response.data);
    })
    .catch((error) => {
      setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
    })
    .finally(() => {
      setReload(false);
      setLoading(false);
    });
  }, [reload, userId]);

  const deleteEntry = (id) => {
    const token = localStorage.getItem('token');

    axios.delete('/api/delete-service-file', {
      data: { id },
      headers: {
        Authorization: `Bearer ${token}`,
      }
    })
    .then((response) => {
      openTimeModal('Запись удалена', 'success');
      setReload(true);
    })
    .catch((error) => {
      openTimeModal(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
    })
    .finally(() => {
      setLoading(false);
    });
  };

  const [isModal, setIsModal] = React.useState(false);

  const [confirmDeleteId, setConfirmDeleteId] = React.useState(null);

  React.useEffect(() => {
    if (confirmDeleteId !== null) {
      const timeout = setTimeout(() => setConfirmDeleteId(null), 3000);
      return () => clearTimeout(timeout);
    }
  }, [confirmDeleteId]);

  const [isFileViewerModal, setIsFileViewerModal] = React.useState(false);
  const [currentFileId, setCurrentFileId] = React.useState('');


  return (
    <>
      {isModal && <AddNewPDConsentTemplate closeModal={() => setIsModal(false)} onSuccess={() => {setIsModal(false); setReload(true)}} /> }
      <ModalRight isOpen={isFileViewerModal} closeModal={() => setIsFileViewerModal(false)} >
        <FileViewerModal closeModal={() => setIsFileViewerModal(false)} id={currentFileId} />
      </ModalRight>

      <div className='tableContainer'>
        <div className='tableHeaderWrapper'>
          <div className='tableStatus'>
              <button type='button' className='secondaryButton' onClick={() => setIsModal(true)}>
                <svg viewBox="0 0 24 24" id="plus" fill="currentColor">
                  <path d="M19,11H13V5a1,1,0,0,0-2,0v6H5a1,1,0,0,0,0,2h6v6a1,1,0,0,0,2,0V13h6a1,1,0,0,0,0-2Z"></path>
                </svg>
                Добавить новый шаблон
              </button>
              <a className='lastUpdateWrapper'>
                  {loading ? 
                      <Loading type='inline' /> 
                  : 
                      <IconContainer Icon={ReloadIcon} onClick={() => setReload(true)} size = '14' color = 'black' className = '' />
                  }
              </a>
          </div>
          <div className='tableHeader' style={{ gridTemplateColumns: '60fr 34fr 6fr' }}>
              <div>Название файла</div>
              <div>Дата загрузки</div>
              <div></div>
          </div>
        </div>
        {loading ? <LoadingLines /> 
        : warning ? <WarningPanel text={warning} inTable={true} buttonText='Обновить' buttonAction={() => setReload(true)} />
        : cases.map((caseItem, index) => (
            <div 
              className='tableRow nonActive' 
              style={{ gridTemplateColumns: '60fr 34fr 6fr' }}
              key={caseItem.id} 
            >
              <div>
                <p style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                  {formatNull(caseItem.file_name)} 
                  {index === 0 && ' (текущий шаблон)'}
                  <IconContainer Icon={EyeIcon} onClick={() => {setIsFileViewerModal(true); setCurrentFileId(caseItem.file_id);}} size='17' color='blue' className='' />
                </p>
              </div>
              <div>{formatDateTime(caseItem.created_at)}</div>
              <div style={{alignItems: 'end'}}>
                {confirmDeleteId === caseItem.id ?
                  <button className='tableButton red' onClick={() => deleteEntry(caseItem.id)}>Удалить?</button>
                :
                  <div className='horizontalCell'>
                    <IconContainer Icon={TrashIcon} onClick={() => setConfirmDeleteId(caseItem.id)} size='17' color='red' className='' />
                  </div>}
              </div>
            </div>
        ))}
      </div>
    </>
  )
}

export default TemplatesConsentPersonalData;